import { Injectable } from '@angular/core';
import { PITEventService } from '@pit/core';

@Injectable({
    providedIn: 'root'
})
export class ErrorNotificationService {

    constructor(private eventService: PITEventService) {
    }

    public showHttpError(statusCode: number, operation: string, url?: string): void {
        const message = this.getGermanHttpStatusMessage(statusCode);

        // Don't show error for success status codes
        if (message === null) {
            return;
        }

        const operationText = this.getGermanOperationText(operation, url);

        this.eventService.sendEvent('message', {
            severity: 'error',
            summary: `${operationText} fehlgeschlagen`,
            detail: `${message} (Status: ${statusCode})`,
            sticky: false,
            life: 3000
        });
    }

    private getGermanHttpStatusMessage(statusCode: number): string {
        switch (statusCode) {
            case 200:
            case 201:
            case 204:
                // Success codes should not be treated as errors
                return null;
            case 400:
                return 'Ungültige Anfrage - Die gesendeten Daten sind fehlerhaft';
            case 401:
                return 'Nicht autorisiert - Bitte melden Sie sich erneut an';
            case 403:
                return 'Zugriff verweigert - Keine Berechtigung für diese Aktion';
            case 404:
                return 'Nicht gefunden - Die angeforderte Ressource existiert nicht';
            case 405:
                return 'Methode nicht erlaubt - Diese Aktion ist nicht zulässig';
            case 409:
                return 'Konflikt - Die Daten wurden bereits von jemand anderem geändert';
            case 413:
                return 'Datei zu groß - Die hochgeladene Datei überschreitet die zulässige Größe';
            case 422:
                return 'Unverarbeitbare Daten - Die gesendeten Daten sind ungültig';
            case 429:
                return 'Zu viele Anfragen - Bitte versuchen Sie es später erneut';
            case 500:
                return 'Serverfehler - Ein interner Fehler ist aufgetreten';
            case 502:
                return 'Gateway-Fehler - Der Server ist nicht erreichbar';
            case 503:
                return 'Service nicht verfügbar - Der Server ist überlastet';
            case 504:
                return 'Gateway-Timeout - Der Server antwortet nicht';
            case 0:
                return 'Netzwerkfehler - Keine Verbindung zum Server';
            default:
                if (statusCode >= 200 && statusCode < 300) {
                    // All 2xx status codes are success
                    return null;
                }
                return `Unbekannter Fehler - HTTP Status ${statusCode}`;
        }
    }

    private getGermanOperationText(operation: string, url?: string): string {
        const lowerOp = operation.toLowerCase();
        const lowerUrl = url ? url.toLowerCase() : '';
        
        // Check for specific contexts based on URL
        if (lowerUrl.includes('version') || lowerUrl.includes('upload')) {
            if (lowerOp.includes('save') || lowerOp.includes('create') || lowerOp.includes('post')) {
                return 'Version-Upload';
            }
        } else if (lowerUrl.includes('login') || lowerUrl.includes('auth')) {
            return 'Anmeldung';
        }
        
        // Default operation mapping
        if (lowerOp.includes('save') || lowerOp.includes('create') || lowerOp.includes('post')) {
            return 'Speichern';
        } else if (lowerOp.includes('update') || lowerOp.includes('put') || lowerOp.includes('patch')) {
            return 'Aktualisierung';
        } else if (lowerOp.includes('delete') || lowerOp.includes('remove')) {
            return 'Löschen';
        } else if (lowerOp.includes('get') || lowerOp.includes('load') || lowerOp.includes('fetch')) {
            return 'Laden';
        } else {
            return 'Operation';
        }
    }
}